<template>
  <div class="container">
    <Sidebar></Sidebar>
    <nav class="nav-extended blue-nav">
      <div class="nav-wrapper">
          <span class="nav-title">
            Manage users
          </span>
      </div>
      <div class="nav-content ">
        <div class="fixed-action-btn horizontal direction-top direction-left click-to-toggle"
          style="display: inline-block; position:absolute;  right:25px; bottom: -25px;">
          <a class="btn-floating btn-large gray-fab main waves-effect waves-light z-depth-3 " v-on:click="fabClick" >
            <i class="large material-icons">add</i>
          </a>
          <ul style="max-width: 200px !important;">
            <li><a href="#user-invite" class="btn-floating white secondary-btn" v-on:click="groupForm">
              <i class="material-icons grey-text">group</i>
            </a></li>
            <li><a class="btn-floating white secondary-btn" v-on:click="userForm">
              <i class="material-icons grey-text">person</i></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Invite Forms -->
    <div id="userInvite" class="invite-form">

      <div class="row valign-wrapper">

        <div class="input-field col m5 s12">
          <input id="fullName" type="text" placeholder="Alex Kuklinski"  v-model="user.name">
          <label for="fullName">Full name*</label>
          <span class="helper-text" data-error="Please enter a valid email" data-success="">Who are you inviting?</span>
        </div>
        <div class="input-field col m5 s12">
          <input id="userEmail" type="email" class="validate" placeholder="alex@fyi.io" v-model="user.email">
          <label for="userEmail">Email*</label>
          <span class="helper-text" data-error="invalid email">What is their email address?</span>
        </div>
        <div class="col m2 s12 right-align">
          <button class="waves-effect waves-light blue btn" v-on:click="inviteUser" v-bind:disabled="this.inviting || !this.canInviteSingle">
            <span v-if="inviting">Inviting...</span>
            <span v-if="!inviting">Invite</span>

          </button>
        </div>
      </div>

      <div class="row">
        <p class="invite-links"><a href="#"  v-on:click="groupForm">Add a bunch instead</a></p>
      </div>
    </div>

    <div id="groupInvite" class="row valign-wrapper invite-form">
      <div class="input-field col m10 s12">
        <input id="groupEmails" type="email" placeholder="alex@fyi.io, dan@fyi.io, suz@fyi.io" v-model="group_emails">
        <label for="groupEmails">Email*</label>
        <span class="helper-text" data-error="wrong" data-success="right">Separate each email address with a comma</span>
      </div>
      <div class="col m2 s12 right-align">
        <button class="waves-effect waves-light blue lighten-1 btn" v-on:click="inviteGroup" v-bind:disabled="this.inviting || !this.canInviteMultiple">
            <span v-if="inviting">Inviting...</span>
            <span v-if="!inviting">Invite</span>
        </button>
      </div>
    </div>

    <div v-if="showFreeBanner" >
      <h6 class="center">The free plan allows for 1 active user. To add more users, <a href="/settings#plan">please upgrade to the Team plan.</a><br><br></h6>
    </div>
    <div v-if="showMakerBanner" >
      <h6 class="center">The Maker plan allows for 1 active user. To add more users, <a href="/settings#plan">please upgrade to the Team plan.</a><br><br></h6>
    </div>
    <div v-if="showTeamBanner" >
      <h6 class="center">The Team plan allows for 10 active users. To add more users, <a href="/settings#plan">please upgrade to an Enterprise Plan.</a><br><br></h6>
    </div>
    <!-- Users -->
    <div class="progress" v-if="loading">
      <div class="indeterminate"></div>
    </div>
    <!-- <div id="servicebot-request-form"></div>
     -->
     
    <div v-if="!users || (users && users.length == 0)" class="row">
      <h3 class="collection-header">Welcome to fyiio</h3>
      <ul class="collection s12">
        <li class="collection-item row valign-wrapper">
          <div class="col s11">
            <div>Add one or a bunch of users</div>
            <span class="author">Click the orange circle</span>
          </div>
          <div class="col s1 right-align ">
            <i class="material-icons">arrow_upward</i>
          </div>
        </li>
      </ul>
    </div>

    <div id="users" class="row" v-if="!loading && (users && users.length)">
      <h3 class="collection-header">Staff</h3>

      <ul class="collection s12">
        <li v-for="(item, index) in users" :key="index" class="collection-item row valign-wrapper">
          <div class="col s10">
            <div>{{ item.name || item.user_id }}</div>
              <ul v-bind:id="'dropdown'+index" class='dropdown-content'>
                <li><a ><i class="material-icons">mode_edit</i>Edit</a></li>
                <li class="divider" tabindex="-1"></li>
                <li><a  v-bind:data-id="item.user_id" v-on:click="deleteConfirm"><i class="material-icons">delete</i>Delete</a></li>
              </ul>
            </div>
          <div class="col s2 right-align ">
            <!-- <a class='dropdown-trigger' href='#' v-bind:data-target="'dropdown'+index">
              <i class="material-icons">more_vert</i>
            </a> -->
            <button class="btn-flat white waves-effect blue-text"
              v-bind:data-id="item.user_id"
              v-on:click="deleteConfirm"
              v-if="item.user_id != user_id && role == 'admin'"
             >
              REMOVE
            </button>
          </div>
        </li>
      </ul>
    </div>

    <div id="deleteModal" class="delete-modal modal">
      <div class="modal-content">
        <h5>Are you sure you want to remove this user?</h5>
        <p>{{ deleteId }}</p>
      </div>
      <div class="modal-footer">
        <a  class="modal-action modal-close waves-effect waves-grey btn-flat">Cancel</a>
        <!-- <a href="#!" class="modal-action modal-close waves-effect waves-grey btn-flat red-text">Coming Soon!</a> -->
        <a  v-on:click="deleteUser" class="modal-action modal-close waves-effect waves-red red-text btn-flat">Delete</a>
      </div>
    </div>
    <!-- Modal Structure -->
    <div id="modalFeatureGate" class="modal feature-modal modal-fixed-footer">
      <div class="modal-content">
        <h4>Upgrade to invite additional users</h4>
        <p v-if="showFreeBanner">The free plan allows for one active user.</p>
        <p v-if="showMakerBanner">The Maker plan allows for one active user.</p>
        <p v-if="showTeamBanner">The Team plan allows for 10 active users.</p>
        <p v-if="showFreeBanner">Head on over to the <a href="/settings#plan">select a plan page</a> to upgrade to the Team plan</p>
        <p v-if="showMakerBanner">Head on over to the <a href="/settings#plan">select a plan page</a> to upgrade to the Team plan</p>
        <p v-if="showTeamBanner">Head on over to the <a href="/settings#plan">select a plan page</a> to find the right plan for your needs.</p>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat">Cancel</a>
        <a href="/settings#plan" class="modal-close waves-effect waves-green btn-flat">Select a plan</a>
      </div>
    </div>
  </div>
</template>

<script>
import featureGate from '@/mixins/featureGate'
import Sidebar from '@/components/Sidebar'
import GqlQuery from '@/plugins/gql'
import cognitoAuth from '@/plugins/cognito'
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
function initFab() {
  M.AutoInit();
  var elem = document.querySelector('.fixed-action-btn');
  var instance = M.FloatingActionButton.init(elem, {
    direction: 'left',
    hoverEnabled: false
  });
}
function hideForms() {
  Array.filter( document.getElementsByClassName('invite-form'), function(elem){ elem.classList.remove('active') });

}
function showForm(formId) {
  Array.filter( document.getElementsByClassName('secondary-btn'), function(elem){ elem.style.visibility = "hidden" });
  hideForms();
  document.getElementById(formId).classList.add('active');
  initFab();
  M.updateTextFields();
}

export default {
  mounted() {
    initFab();
    var self = this;
    cognitoAuth.getUserAttributes(function(err, user_attributes) {
      self.organization_id = user_attributes['custom:organization_id']
      self.user_id = user_attributes['email']
      self.role = user_attributes['custom:method_of_boarding']
    })

    GqlQuery.getOrganization(function(err, response){
      if (err) {
        console.log("err: ", err)
      }
      response.then(async function(resp) {
        self.organization_id = resp.data.organizations[0].id
        await self.getUserPermissions(self.organization_id)
        self.plan=resp.data.organizations[0].plan
        self.plan_status=resp.data.organizations[0].plan_status
        self.loading = false;
        self.checkPlanForUsers(self.plan,self.plan_status,self.users)
      })
    })
  },
  created() {
    // to prevent some race condition that'd overwrite the fab click only option
    window.setTimeout(initFab, 50);
  },
  name: 'Users',
  mixins: [featureGate],
  data () {
    return {
      inviting: false,
      loading: true,
      role: 'single',
      deleteId: '',
      organization_id: '',
      user_id: '',
      user: {
        name: '',
        email: ''
      },
      group_emails: '',
      users: [],
      plan: '',
      plan_status: ''
    }

  },
  computed: {
    canInviteUser: function() {
      let self=this;
      console.log("plan:",self.plan)
      let hold=self.checkPlanForUsers(self.plan,self.plan_status,self.users)
      
      return hold;
    },
    canInviteSingle: function() {
      return this.user.name.length > 1 && validateEmail(this.user.email)
    },
    canInviteMultiple: function() {
      let emails = this.group_emails.split(",");
      let canInvite = true
      for(let i in emails) {
        let email = emails[i]
        if (!validateEmail(email.trim())) {
          canInvite = false
        }
      }
      return canInvite
    }
  },

  methods: {
    featureGateAction(action) {
      var options = {dismissible: false};
      var elem = document.querySelector('.feature-modal');

      // allow time for dom to react to data change
      setTimeout(function(){
        var instance = M.Modal.init(elem, options);
        instance.open();
      }, 1)
    },
    userForm: function(event) {
      if(this.canInviteUser) {
        showForm('userInvite')
      }else{
        this.featureGateAction('Plan limit reached');
      }
    },
    groupForm: function(event) {
      if(this.canInviteUser) {
        showForm('groupInvite')
      }else{
        this.featureGateAction('Plan limit reached');
      }
    },
    fabClose: function(event) {
    },
    fabClick: function(event) {
      if (event.target.classList.contains('rotated')) {
        hideForms();
        event.target.classList.remove('rotated');
      } else {
        event.target.classList.add('rotated');
        Array.filter( document.getElementsByClassName('secondary-btn'), function(elem){ elem.style.visibility = "visible" });
      }
    },
    async getUserPermissions(organization_id) {
      //console.log("In get User PErmissions")
      var self = this;
      GqlQuery.getUserPermissions(organization_id, function(err, permRepsonse) {
        if (err) {
          console.log("error getting user permissions")
        }
        permRepsonse.then(function(permissions) {
          //console.log(permissions.data)
          self.users = permissions.data.permissions
        })
      })
    },
    deleteUser(event) {
      var self = this;
      GqlQuery.deleteUserPermissions(this.deleteId, function(err, permRepsonse) {
        if (err) {
          M.toast({html: 'Error removing user, please try again'}, 4000)
        }
        permRepsonse.then(function(permissions) {
          M.toast({html: 'User removed!'}, 4000)
          self.getUserPermissions(self.organization_id)
        })
      })
    },
    deleteConfirm(event) {
      this.deleteId = event.target.getAttribute('data-id');
      var options = {};
      var elem = document.querySelector('.delete-modal');
      // allow time for dom to react to data change
      setTimeout(function(){
        var instance = M.Modal.init(elem, options);
        instance.open();
      }, 10)
    },
    inviteUser: function(event) {
      var self = this;
      this.inviting = true;
      var users = [{
        user_id: this.user.email,
        name: this.user.name,
        email_address: this.user.email
      }]
      console.log("self.organization_id: ", self.organization_id)
      GqlQuery.inviteUsers(users, self.organization_id, function(err, response) {
        if (err) {
          self.error = err;
          M.toast({html: 'Error inviting user, please try again'}, 4000)
        } else {
          M.toast({html: 'User invited!'}, 4000)
        }
        self.inviting = false;
        self.user.name = ""
        self.user.email = ""
        self.getUserPermissions(self.organization_id)
      })
    },
    inviteGroup: function(event) {
      var self = this;
      self.inviting = true;
      var emails = this.group_emails.split(",");
      var users = emails.map(function(email) {
        email = email.trim();
        return {
          user_id: email,
          name: email,
          email_address: email
        }
      })
      GqlQuery.inviteUsers(users, self.organization_id, function(err, response) {
        if (err) {
          self.error = err;
          M.toast({html: 'Error inviting users, please try again'}, 4000)

        } else {
          M.toast({html: 'Users invited!'}, 4000)
        }
        self.inviting = false;
        self.group_emails = ''
        self.getUserPermissions(self.organization_id)
      })
    }
  },
  components: {
    Sidebar
  }
}
</script>

<style scoped>
ul.collection {
  border: none;
}
.dropdown-content {
  min-height: 105px;
  min-width: 150px;
}
.fixed-action-btn > ul > li {
  float: right;
  margin-right: 0;
  margin-top: 12px;
}
.invite-links {
  font-size: 14px;
  padding-left: 10px;
}
.invite-form {
    transition: opacity 0.4s ease-in-out;
    transition: max-height 0.4s ease-in-out;
    opacity: 0;
    height: 0;
    overflow: hidden;
    max-height: 0px;
}
.invite-form.active {
    opacity: 1;
    height: auto;
    max-height: 400px;
}
.rotated {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
}
.main.btn-floating i{
  -webkit-transition: -webkit-transform .8s ease-in-out;
    -ms-transition: -ms-transform .8s ease-in-out;
    transition: transform .4s ease-in-out;
}
.gray-fab {
  background-color: #58595B;
}
.btn.blue:disabled {
  background-color: #f1f1f1!important;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/Users.vue